import { BitrixVue, reactive } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { VplRouter } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const ProektirovanieSection = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    updated(){

    },
    mounted(){

        if($(this.$el).find('.js-instrument-slider').length){
            let mpSwiperServ = new Swiper('.js-instrument-slider', {
                loop: true,
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 30,
                autoplay: {
                delay: 3000
                },
                pagination: {
                el: ".js-instrument-pag",
                type: "bullets",
                clickable: true
                },
                navigation: {
                nextEl: ".js-instrument-btn-next",
                prevEl: ".js-instrument-btn-prev"
                }
            });
        }

        if($(this.$el).find('[data-fancybox]').length){
            $(this.$el).find('[data-fancybox]').fancybox({
                loop: true,
            });
        }

        if(this.ancor){
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#" + this.ancor).offset().top - 60
            }, 500);
        }

    },
    methods: {
        showModalForm(){
            $('#order').modal();
        },
        zoomIn(){
            $(this.$el).find('.swiper-slide-active').find('a').trigger('click');
        },
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData', 'SITE_TEMPLATE_PATH', 'struct', 'title', 'ancor'])
    },
    template: `
<div style="display: contents;">
<section class="section section--first">
    <div class="container">
        <div class="projects__intra">
            <div class="projects__intra-text content">
                <div style="display: contents;" v-html="this.struct[this.structKey].componentData.DESCRIPTION">
                </div>
                <a href="#" class="btn btn--green" @click.prevent="showModalForm()">Отправить заявку</a>
            </div>

            <div v-if="this.struct[this.structKey].componentData.GALLERY && this.struct[this.structKey].componentData.GALLERY.length" class="projects__intra-rightside js-instrument-slider-wp">
                <div class="projects__intra-rightside-inner">
                    <div class="swiper projects__intra-slider js-instrument-slider">
                        <div class="swiper-wrapper">

                            <div v-for="galItem in this.struct[this.structKey].componentData.GALLERY" class="swiper-slide">
                                <a :href="galItem.BIG" class="projects__intra-slider-img" data-fancybox="project-detail">
                                    <img :src="galItem.MEDIUM" :alt="this.struct[this.structKey].componentData.NAME" :title="this.struct[this.structKey].componentData.NAME" loading="lazy">
                                </a>
                            </div>

                        </div>
                    </div>
                    <a href="#" class="zoom js-instrument-zoom" @click.prevent="zoomIn()">
                        <svg class="icon icon-zoom"><use xlink:href="#icon-zoom"></use></svg>
                    </a>
                    <div class="slider-arrows">
                        <div class="swiper-button-prev slider-btn js-instrument-btn-prev">
                            <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                        </div>
                        <div class="swiper-button-next slider-btn js-instrument-btn-next">
                            <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination js-instrument-pag"></div>
            </div>
            <div v-else class="projects__intra-rightside">
                <div class="projects__intra-rightside-inner">
                    <div class="swiper projects__intra-slider">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <span class="projects__intra-slider-img no-photo">
                                    <img :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" alt="" title="" loading="lazy">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</section>
<section v-if="this.struct[this.structKey].componentData.ITEMS.length" class="section">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Мы оснащаем и поставляем оборудование {{this.struct[this.structKey].componentData.FOR_HEADER}}
                </h2>
            </div>
        </div>
        <div class="equipment-page__list">
            <div v-for="item in this.struct[this.structKey].componentData.ITEMS" class="equipment-page__list-item">
                <a :href="item.LINK" class="equipment-page__list-item-img" :class="{'no-photo': item.IMAGE === false}">
                    <img v-if="item.IMAGE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.IMAGE" :alt="item.NAME" :title="item.NAME">
                    <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME">
                </a>
                <a :href="item.LINK">{{item.NAME}}</a>
            </div>
        </div>
    </div>
</section>
</div>
    `
}